export default __webpack_public_path__ + "static/media/3.dafc8aa7.webp";